export default {
  idc_corset: false,
  type_corset: null,

  idc_taking_measurement: false,
  type_measurement: null,
  idc_radio: false,
  idc_sternal_support: false,
  idc_bi_clavicular_support: false,
  lombar: null,
  observation: null,

  butt: null,
  belly: null,
  chest: null,
  idc_sagging_chest: false,
  blob_corset: null,
  blob_decoupe: null,
  a1: null,
  a2: null,
  a3: null,
  a4: null,
  a5: null,
  a6: null,
  a7: null,
  b1: null,
  b2: null,
  b3: null,
  b4: null,
  b5: null,
  b6: null,
  b7: null,
  c1: null,
  c2: null,
  c3: null,
  c4: null,
  c5: null,
  c6: null,
  c7: null,
  d1: null,
  d2: null,
  d3: null,
  d4: null,
  d5: null,
  d6: null,
  d7: null,
  e: null,
  f: null,
  g: null,

  idc_manufacture: false,
  type_production: null,
  manufacturing_type: null,
  manufacturing_thickness: null,
  garnishing: null,
  transfer_id: null,
  other_production: null,

  tshirt_quantity: null,
  tshirt_size: null,
  material: null,
  thickness: null,
  idc_velcro_bystander_40: false,
  idc_velcro_bystander_25: false,
  idc_clip: false,
  idc_rigid_clip: false,
  idc_elastic_clip: false,
  idc_velcro_bystander: false,
  comment_production: null,
  other_lpr: null,
  articles: []
};
